import { CoPilotNavigationTab } from 'features/co-pilot/co-pilot-routes';
import CampaignCoPilot from 'pages/campaign-co-pilot';
import React from 'react';
import { useOutletContext } from 'react-router';

import { CoPilotOutletContext } from './co-pilot-root-layout';
import { useCoPilotTabRouteSync } from './hooks/use-co-pilot-tab-route-sync';

interface Props {
  tab: CoPilotNavigationTab;
}

const CoPilotTabPage: React.FC<Props> = ({ tab }) => {
  const { productGroup } = useOutletContext<CoPilotOutletContext>();
  useCoPilotTabRouteSync(tab);

  return <CampaignCoPilot productGroup={productGroup} />;
};

export default CoPilotTabPage;
